import src from "IMAGE";
export default { src, width: 2752, height: 1536, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAIAAAA8r+mnAAAASklEQVR42j2JSwrAIAxEvf/tdGFtu+mHWowX0OCIwYDDwHye6YA6PRe995pGQxSs3Z3DAow2f2z+CP7UzgKIS53sixT/LEVm5joA8dNbu+WNIFEAAAAASUVORK5CYII="};
